import { isDevelopment } from '@/enums/app'
import { stripWebsiteAndLocaleAndCountry } from '@/utils/general'
import { datadogRum } from '@datadog/browser-rum'

export default ({ store, $config }) => {
  datadogRum.init({
    applicationId: process.env.DATADOG_APP_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'nuxt-frontend',
    env: process.env.DD_ENV,
    version: $config.DD_VERSION,
    allowedTracingUrls: [url => url.startsWith(process.env.API_URL)],
    sessionSampleRate: isDevelopment ? 100 : 30,
    sessionReplaySampleRate: 5,
    trackUserInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    traceSampleRate: 0,
    traceContextInjection: 'sampled',
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {
      event.context = event.context || {}

      const url = stripWebsiteAndLocaleAndCountry(event.view.url)

      if (event.type === 'view') {
        event.context.fullUrl = `${event.view.url}`
        event.view.url = `${process.env.BASE_URL}${url}`

        event.context.country = store.state.app.country
        event.context.locale = store.state.app.locale

        if (store.state.auth.userId) {
          event.context.userId = store.state.auth.userId
        } else if (store.state.signup.form.prospectId) {
          event.context.prospectId = store.state.signup.form.prospectId
        } else if (store.state.womenSignup.form.prospectId) {
          event.context.prospectId = store.state.womenSignup.form.prospectId
        }

        return true
      }

      return true
    }
  })
}
